

























import Vue from 'vue';
import Component from 'vue-class-component';
import SectionLayout from '@/components/SectionLayout.vue';
import { ChallengeModel } from '@/models/challenge.model';
import ListScaffold from '@/components/Shared/ListScaffold.vue';
import ChallengeCard from '@/components/ChallengeCard.vue';
import { ChallengesApi } from "@/api/challenges.api";
import { take } from "rxjs/operators";
import { finishedChallengesModule, finishedChallengesState, inProgressChallengesModule } from "@/utils/store-acessor";

@Component({
  components: { ChallengeCard, ListScaffold, SectionLayout }
})
export default class HomeSixChallenges extends Vue {
  @inProgressChallengesModule.Getter('challenges') activeChallenges!: ChallengeModel[];
  @finishedChallengesModule.Getter('challenges') finishedChallenges!: ChallengeModel[];

  activeChallengesPriority: ChallengeModel[] = [];
  loading = false
  finishedLoading = false
  finishedChallengesPriority: ChallengeModel[] = [];

  get finished(): ChallengeModel[] {
    return this.finishedChallengesPriority.length < 1 ? this.finishedChallenges : this.finishedChallengesPriority
  }

  get actives(): ChallengeModel[] {
    return this.activeChallengesPriority.length < 1 ? this.activeChallenges : this.activeChallengesPriority
  }

  async mounted() {
    await finishedChallengesState.fetchAll({ page: 1 });
    this.loading = true
    this.finishedLoading = true
    new ChallengesApi()
      .fetchHomeActiveChallenges()
      .pipe(take(1))
      .subscribe((challenges) => {
        this.loading = false
        this.activeChallengesPriority = challenges
      }, () => this.loading = false)
    new ChallengesApi()
      .fetchHomeFinishedChallenges()
      .pipe(take(1))
      .subscribe((challenges) => {
        this.finishedLoading = false
        this.finishedChallengesPriority = challenges
      }, () => this.finishedLoading = false)
  }

  animate(direction: string) {
  }

  openChallenges() {
    this.$router.push(`/challenges`);
  }
}
